import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

const INTERNET_VALUE = "internet";

const selectCountriesState = (state: RootState) => state.countries;

export const selectCountriesWithInterner = createSelector(
  selectCountriesState,
  ({ countries }) => countries
);

export const selectCountries = createSelector(
  selectCountriesState,
  ({ countries }) => {
    return {
      ...countries,
      items: countries.items.filter(({ value }) => value !== INTERNET_VALUE),
    };
  }
);
